import { Link } from 'react-router-dom';

const termsItems = [
  '服務範圍：本店由私廚主廚 Alex 親自把關食材，以優惠團購價為顧客搜羅優質食材及調味品，並提供港九新界快遞配送服務。',
  '訂單成立：訂單須經本店確認付款後方為生效；未達最低消費或缺貨時，我們保留取消權利。',
  '送貨：我們按訂單資料安排送貨，顧客應確保地址及聯絡電話正確。',
  '取消與退款：付款確認後如需取消，請盡快聯絡客服，我們會按個別情況處理。',
  '價格與內容：菜單、價格及供應可能隨時調整，以網站最後公布為準。',
  '責任限制：在法律允許範圍內，本店對因不可抗力或顧客提供錯誤資料導致的損失不承擔責任。',
  '準據法：本服務條款受香港法律管轄。',
];

export default function TermsOfService() {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 py-8 px-4 sm:px-6 lg:px-8 transition-colors">
      <div className="max-w-3xl mx-auto">
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6 md:p-10 transition-colors">
          <h1 className="text-2xl md:text-3xl font-bold text-gray-900 dark:text-white mb-2">
            阿力廚房 Alex Kitchen
          </h1>
          <h2 className="text-xl font-semibold text-gray-700 dark:text-gray-200 mb-6">
            服務條款
          </h2>

          <ol className="list-decimal pl-5 space-y-4 text-gray-700 dark:text-gray-300 leading-relaxed">
            {termsItems.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ol>

          <div className="mt-8 pt-6 border-t border-gray-200 dark:border-gray-700">
            <Link
              to="/"
              className="inline-flex items-center text-orange-600 hover:text-orange-700 dark:text-orange-400 dark:hover:text-orange-300 font-medium"
            >
              ← 返回首頁
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
